// src/components/common/PageControls/PageControls.jsx
import React from 'react';
import { Filter, X } from 'lucide-react';
import styles from './PageControls.module.css';

/**
 * PageControls Component
 * Controls bar for list pages with search, filters, and actions
 * 
 * @param {Object} props
 * @param {ReactNode} props.left - Content for left side (typically search bar)
 * @param {ReactNode} props.right - Content for right side (typically actions/selectors)
 * @param {boolean} props.showFilterButton - Show filter toggle button
 * @param {boolean} props.filtersActive - Indicate if filters are active
 * @param {function} props.onFilterToggle - Callback when filter button clicked
 * @param {number} props.activeFiltersCount - Number of active filters (shows badge)
 * @param {boolean} props.showClearFilters - Show clear all filters button
 * @param {function} props.onClearFilters - Callback when clear filters clicked
 * @param {string} props.className - Additional CSS class
 * @param {ReactNode} props.children - Custom content (replaces default layout)
 */
const PageControls = ({
  left,
  right,
  showFilterButton = false,
  filtersActive = false,
  onFilterToggle,
  activeFiltersCount = 0,
  showClearFilters = false,
  onClearFilters,
  className = '',
  children
}) => {
  // If children provided, use custom layout
  if (children) {
    return (
      <div className={`${styles.pageControls} ${className}`}>
        {children}
      </div>
    );
  }

  return (
    <div className={`${styles.pageControls} ${className}`}>
      <div className={styles.controlsLeft}>
        {left}

        {showFilterButton && (
          <button
            onClick={onFilterToggle}
            className={`${styles.filterButton} ${filtersActive ? styles.active : ''}`}
            type="button"
          >
            <Filter size={18} />
            <span>Filters</span>
            {activeFiltersCount > 0 && (
              <span className={styles.filterBadge}>{activeFiltersCount}</span>
            )}
          </button>
        )}

        {showClearFilters && (
          <button
            onClick={onClearFilters}
            className={styles.clearAllButton}
            type="button"
          >
            <X size={16} />
            <span>Clear All</span>
          </button>
        )}
      </div>

      {right && (
        <div className={styles.controlsRight}>
          {right}
        </div>
      )}
    </div>
  );
};

export default PageControls;